import { render, staticRenderFns } from "./modalSendCoins_managerMarket.vue?vue&type=template&id=53c5803c&scoped=true"
import script from "./modalSendCoins_managerMarket.vue?vue&type=script&lang=js"
export * from "./modalSendCoins_managerMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5803c",
  null
  
)

export default component.exports